<template>
  <a-swiper
    :swipe-list="slides"
    :custom-options="swiperOptions"
    :display-arrows="false"
    :pagination="false"
    class="winners-highlights-slider__wrapper"
  >
    <div
      slot-scope="{ slide, index }"
      class="winners-highlights-section__slide-wrapper"
    >
      <div
        v-focusable
        :id="getSlideContainerId(index, 0)"
        class="winners-highlights-section__click-handler"
        @click="onClickMedia(slide[0], index, 0)"
      >
        <div class="winners-highlights-section__no-click">
          <a-media
            :image-url="slide[0].previewImageUrl"
            :video-url="slide[0].videoUrl"
            :video-aspect-ratio="$options.consts.ASPECT_RATIO.YOUTUBE_VIDEO"
            :width="$options.consts.PREVIEW_MEDIA_WIDTH"
            :height="$options.consts.PREVIEW_MEDIA_HEIGHT"
            :style="dynamicMediaStyles"
            :disable-focus-on-video="true"
            class="winners-highlights-section__media"
          />
        </div>
      </div>

      <a-visibility v-if="slide[1]" :show="true" :from="$breakpoint.desktopLg">
        <div
          v-focusable
          :id="getSlideContainerId(index, 1)"
          class="winners-highlights-section__click-handler"
          @click="onClickMedia(slide[1], index, 1)"
        >
          <div class="winners-highlights-section__no-click">
            <a-media
              :image-url="slide[1].previewImageUrl"
              :video-url="slide[1].videoUrl"
              :video-aspect-ratio="$options.consts.ASPECT_RATIO.YOUTUBE_VIDEO"
              :width="$options.consts.PREVIEW_MEDIA_WIDTH"
              :height="$options.consts.PREVIEW_MEDIA_HEIGHT"
              :style="dynamicMediaStyles"
              :disable-focus-on-video="true"
              class="winners-highlights-section__media bottom"
            />
          </div>
        </div>
      </a-visibility>
    </div>
  </a-swiper>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import ASwiper from 'shared/ASwiper'
import { MODAL } from 'modals/AModalWrapper/enums'
import AMedia from 'shared/AMedia'
import { ASPECT_RATIO } from 'enums/aspectRatios'

export default {
  name: 'WinnersHighlightsSlider',
  components: { ASwiper, AMedia },
  props: {
    slides: propValidator([PROP_TYPES.ARRAY])
  },
  consts: {
    ASPECT_RATIO,
    PREVIEW_MEDIA_WIDTH: 286,
    PREVIEW_MEDIA_HEIGHT: 190
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 24
      }
    }
  },
  computed: {
    dynamicMediaStyles() {
      return this.$helper.generateAspectRatioStyle(ASPECT_RATIO.HIGHLIGHT_IMAGE)
    }
  },
  methods: {
    getSlideContainerId(colIndex, rowIndex) {
      return `slide-container-${colIndex}-${rowIndex}`
    },
    getSlideContainerSelector(colIndex, rowIndex) {
      return `#${this.getSlideContainerId(colIndex, rowIndex)}`
    },
    onClickMedia(media, colIndex, rowIndex) {
      this.$helper.openModal(MODAL.HIGHLIGHTS, {
        media,
        activatorSelector: this.getSlideContainerSelector(colIndex, rowIndex)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.winners-highlights-slider__wrapper {
  @include mobile {
    margin-right: -#{$padding-x-mobile};
  }

  /deep/ .swiper-prev,
  /deep/ .swiper-next {
    div.a-icon svg {
      fill: $c--blue;
    }

    @include mobile {
      display: none;
    }
  }

  /deep/ .swiper-prev {
    left: -25px;
  }

  /deep/ .swiper-next {
    right: -25px;
  }

  /deep/ .swiper__custom-swiper {
    margin: 0;
  }

  .winners-highlights-section__slide-wrapper,
  /deep/ .swiper__list__item {
    $width: (
      $above-desktop-xl: 286px,
      $desktop-md: 198px,
      $mobile: 225px
    );

    @include setStyleByBreakpoint('width', $width);
  }

  /deep/ .swiper__custom-swiper {
    width: 100%;
  }

  .winners-highlights-section__media {
    position: relative;
    width: 100%;

    &.bottom {
      margin-top: 24px;
    }
  }

  .winners-highlights-section__click-handler {
    cursor: pointer;
  }

  .winners-highlights-section__no-click {
    pointer-events: none;
  }

  /deep/ .winners-highlights-section__media img {
    object-fit: contain;
  }
}
</style>
